export default {
  noData: 'Không có dữ liệu',
  EmptyData: 'Chưa có dữ liệu',
  search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  ChangeAvatar: 'Thay ảnh đại diện',
  AppName: 'Tuyển sinh',
  List: {
    ActionColumn: 'Thao tác',
    SearchEmptyText: 'Tìm kiếm',
  },

  command: {
    add: 'Thêm',
    addQuickly: 'Thêm nhanh',
    addNew: 'Thêm mới',
    view: 'Xem',
    continue: 'Tiếp tục',
    edit: 'Sửa',
    update: 'Cập nhật',
    delete: 'Xóa',
    deleteField: 'Xóa thông tin',
    duplicate: 'Nhân bản',
    more: 'Thêm nữa...',
    save: 'Lưu',
    saveNew: 'Lưu & Thêm',
    close: 'Đóng',
    hide: 'Ẩn',
    help: 'Giúp',
    cancel: 'Hủy',
    accept: 'Đồng ý',
    saveAndNew: 'Lưu và thêm mới',
    confirm: 'Xác nhận',
    notConfirm: 'Không xác nhận',
    export: 'Xuất khẩu',
    finish: 'Hoàn thành',
    load: 'Nạp',
    print: 'In',
    filter: 'Lọc',
    refresh: 'Nạp',
    setting: 'Thiết lập',
    default: 'Mặc định',
    list: 'Danh sách',
    addDetail: 'Thêm dòng',
    addDetailShortKey: 'Thêm dòng (F9)',
    import: 'Nhập khẩu',
    logout: 'Đăng xuất',
    next: 'Tiếp theo',
    back: 'Quay lại',
    move: 'Di chuyển',
    minimize: 'Thu gọn',
    sort: 'Sắp xếp thứ tự',
    addNewProFile: 'Thêm hồ sơ',
    upTop: 'Lên đầu',
    downBot: 'Xuống cuối',
    upMove: 'Chuyển lên',
    downMove: 'Chuyển xuống',
    addStudent: 'Thêm hồ sơ',
    chooseSchoolYear: 'Chọn năm học',
    chooseSchoolLevel: 'Chọn cấp học',
    downloadFile: 'Tải tệp',
    downloadTemplateFile: 'Tải tệp mẫu',
    chooseImage: 'Chọn ảnh',
    getData: 'Lấy dữ liệu',
    skip: 'Để sau',
    schoolYear: 'Năm học',
    notification: 'Thông báo',
    viewMore: 'Xem thêm',
    understood: 'Đã hiểu',
    changePassword: 'Đổi mật khẩu',
  },

  module: {
    account: 'Tài khoản',
    enrollmentStudent: 'Hồ sơ học sinh',
  },
  common: {
    Title: 'Tiêu đề',
    Content: 'Nội dung',
  },
}
